<template>
	<SectionCard title="Per piattaforma" icon="mdi-bullhorn-outline" no-padding data-tour="sources">
		<v-simple-table dense>
			<thead>
				<tr>
					<th>Piattaforma</th>
					<th class="text-right">Spesa</th>
					<th class="text-right">Quota</th>
					<th class="text-right">Clic</th>
					<th class="text-right">Costo per clic</th>
					<th class="text-right">Conversioni</th>
					<th class="text-right">Valore dichiarato</th>
					<th class="text-right">ROAS dichiarato</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="s in rows" :key="s.source">
					<td>
						<v-avatar size="18" tile class="mr-2"><img :src="info(s.source).logo" :alt="s.label" /></v-avatar>
						{{ s.label }}
						<v-chip v-if="s.sync && s.sync.status === 'error'" x-small label outlined color="red darken-1" class="ml-1">lettura non riuscita</v-chip>
					</td>
					<td class="text-right as-strong">
						{{ formatEurCents(s.spend) }}
						<div class="as-note">prima {{ formatEurCents(s.previousSpend) }}</div>
					</td>
					<td class="text-right">{{ formatPct(s.share) }}</td>
					<td class="text-right">{{ formatNumber(s.clicks) }}</td>
					<td class="text-right">{{ s.cpc === null ? '—' : formatEurCents(s.cpc) }}</td>
					<td class="text-right">{{ formatNumber(s.conversions) }}</td>
					<td class="text-right">{{ formatEurCents(s.conversionValue) }}</td>
					<td class="text-right" :class="{ 'red--text text--darken-1': below(s) }">{{ formatRoas(s.platformRoas) }}</td>
				</tr>
				<tr v-if="!rows.length">
					<td colspan="8" class="text-center grey--text py-4">Nessuna piattaforma collegata.</td>
				</tr>
			</tbody>
		</v-simple-table>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber, formatPct } from '@/components/dashboard/format';
import { sourceInfo, formatRoas } from './labels';

export default {
	name: 'AdsSources',
	components: { SectionCard },
	props: {
		rows: { type: Array, default: () => [] },
		breakevenRoas: { type: Number, default: null },
	},
	methods: {
		formatEurCents,
		formatNumber,
		formatPct,
		formatRoas,
		info: sourceInfo,
		below(s) {
			return this.breakevenRoas !== null && s.spend > 0 && s.platformRoas !== null && s.platformRoas < this.breakevenRoas;
		},
	},
};
</script>

<style scoped>
.as-note {
	font-size: 11px;
	color: #5f6b7a;
	font-weight: 400;
}
.as-strong {
	font-weight: 600;
}
</style>
